import { Injectable } from '@angular/core';
import {ConfigurationDataService} from '../configuration-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable()
export class LoginService {
  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  /*
  Calls login api to obtain api token for further api calls.
  */
  public login(user : string, password: string ) : any {
    let body = {username : user, password : password};
    console.log('Login provider called.');

    return this.http.post(this.config.apiURL+"user/login", JSON.stringify(body), {headers: this.headers});
  }

  constructor(public http: HttpClient, private config : ConfigurationDataService) {
    console.log('Hello LoginProvider Provider');
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/login/login.service.ts